import type { DashboardLink } from './types';

/** A row nobody has touched: an accidental click on "Connect table". */
export const isBlankLink = (link: DashboardLink): boolean =>
  !link.tableId && !link.viaColumnId && !link.connectedColumnId;

/**
 * A row with some of its three parts filled in — the table, the column of the
 * main table and the column of the connected one (ADR-047). This is a **broken**
 * relation, not an untouched one: a table with nothing to match it by brings no
 * data, so it blocks creating and saving instead of being discarded. A
 * connection saved before ADR-047 (no connected column) is one of these.
 */
export const isPartialLink = (link: DashboardLink): boolean =>
  !isBlankLink(link) && (!link.tableId || !link.viaColumnId || !link.connectedColumnId);
